export default __webpack_public_path__ + "static/cocoa-logo-75cb1828e92cea70d48a4c1695199724.png";